import { ENTITY_TYPES } from '@sales-center/common'
import { isValidDate } from '@sales-center/common'
import type {
  DateRange,
  LimitedDate,
  MultiSelect,
  Nullable,
  SingleSelect,
  ValueRange,
  Ternary,
} from '../typings'

export function getDateRangeSubLabel(
  value: DateRange,
  formatDate: (date: string | number | Date | null | undefined) => string,
) {
  const { start, end, matchType } = value

  let label = ''
  if (matchType === 'bt') {
    if (isValidDate(start) && isValidDate(end))
      label = `From ${formatDate(start)} - To ${formatDate(end)}`
  } else if (isValidDate(start)) {
    label = `${formatDate(start)}`
  } else label = ''

  return label
}

export function getValueRangeSubLabel(value: ValueRange) {
  const { min, max } = value

  let label = ''

  if (min && min !== '') label = `Min $${min}`
  if (max && max !== '') {
    if (label === '') label = `Max $${max}`
    else label += ` - Max $${max}`
  }

  return label
}

export const getLimitedDateSubLabel = (value: LimitedDate) =>
  value?.label.toString() ?? ''

export function getSingleSelectSubLabel(valueSelect: SingleSelect) {
  return valueSelect?.label?.toString() ?? ''
}

export function getMultipleSelectSubLabel(
  filter: MultiSelect,
  filterId?: string,
  salesTeamCount?: number,
) {
  const { options } = filter

  const totOptions = filterId === 'salesTeamId' ? salesTeamCount : undefined

  let label = ''

  if (options.length == 1) label = options[0].label
  if (options.length > 1)
    label =
      totOptions && totOptions > 0 && totOptions === options?.length
        ? 'All'
        : options.map((x) => x.label).join(', ')

  return label
}

export function getNullableSubLabel(
  value: Nullable,
  entityType?: ENTITY_TYPES,
) {
  return value === 'null'
    ? 'Open'
    : value === 'notnull'
    ? entityType === ENTITY_TYPES.Lead
      ? 'Disqualified'
      : 'Closed'
    : ''
}

export function getTernarySubLabel(value: Ternary) {
  return value === 'empty' ? 'All' : value === 'true' ? 'Yes' : 'No'
}
